import { encryptSensitiveData } from '@lcsc-design/utils/crypto';

/**
 * @desc: lcsc统一加密(该加密方式会在localStorage取对应的公钥进行加密)
 * @param {string} str
 * @param {string} encryptPublicHexKey
 * @return {*} 加密字符串
 * @author: 龙健
 */
export default function lcscEncrypt(str) {
  return encryptSensitiveData(str);
}
